import { render, staticRenderFns } from "./SchoolSearchSvg.vue?vue&type=template&id=71951b36&"
import script from "./SchoolSearchSvg.vue?vue&type=script&lang=ts&"
export * from "./SchoolSearchSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports